import React, { Component } from 'react';
import { Grid, Header, Image, Segment } from 'semantic-ui-react';

const lightbulb=require('../../img/icons/lightbulbGreyCircle.svg');
const coffee=require('../../img/icons/coffeeGreyCircle.svg');
const messages=require('../../img/icons/messagesGreyCircle.svg');
const twentyfour=require('../../img/icons/247greyCircle.svg');
const community=require('../../img/icons/commGreyCircle.svg');
const security=require('../../img/icons/securityGreyCircle.svg');
const file=require('../../img/icons/fileGreyCircle.svg');
const brain=require('../../img/icons/brainGreyCircle.svg');

class WhyBB extends Component {
  render() {
    return (
      <Segment style={{ padding: '8em 0em' }} vertical>
        <Grid container stackable>
          <Grid.Row>
            <Grid.Column width={14}>
              <Header as='h3' style={{ fontSize: '2.5em', fontFamiy: 'Raleway', fontFamily: 'serif' }}>Why BeemaBroker?</Header>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={2}>
              <Grid.Row>
                <Image size='tiny' src={lightbulb} />
              </Grid.Row>
            </Grid.Column>

            <Grid.Column width={5}>
              <Grid.Row>
                <p style={{ fontSize: '1.3em', fontFamily: 'Montserrat' }}>Business insurance explained in layman’s terms. </p>
              </Grid.Row>
            </Grid.Column>

            <Grid.Column width={1}>
            </Grid.Column>

            <Grid.Column width={2}>
              <Grid.Row>
                <Image size='tiny' src={coffee}/>
              </Grid.Row>
            </Grid.Column>

            <Grid.Column width={5}>
              <Grid.Row>
                <p style={{ fontSize: '1.3em', fontFamily: 'Montserrat' }}>Designed for millennial entrepreneurs, by millennials. </p>
              </Grid.Row>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={2}>
              <Grid.Row>
                <Image size='tiny' src={messages} />
              </Grid.Row>
            </Grid.Column>

            <Grid.Column width={5}>
              <Grid.Row>
                <p style={{ fontSize: '1.3em', fontFamily: 'Montserrat' }}>Message a licensed broker with ease and efficiency within our application. </p>
              </Grid.Row>
            </Grid.Column>

            <Grid.Column width={1}>
            </Grid.Column>

            <Grid.Column width={2}>
              <Grid.Row>
                <Image size='tiny' src={twentyfour}/>
              </Grid.Row>
            </Grid.Column>

            <Grid.Column width={5}>
              <Grid.Row>
                <p style={{ fontSize: '1.3em', fontFamily: 'Montserrat' }}>Manage your business insurance needs when it’s convenient for you. </p>
              </Grid.Row>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={2}>
              <Grid.Row>
                <Image size='tiny' src={community} />
              </Grid.Row>
            </Grid.Column>

            <Grid.Column width={5}>
              <Grid.Row>
                <p style={{ fontSize: '1.3em', fontFamily: 'Montserrat' }}>Access to a millennial entrepreneurship community.</p>
              </Grid.Row>
            </Grid.Column>

            <Grid.Column width={1}>
            </Grid.Column>

            <Grid.Column width={2}>
              <Grid.Row>
                <Image size='tiny' src={brain}/>
              </Grid.Row>
            </Grid.Column>

            <Grid.Column width={5}>
              <Grid.Row>
                <p style={{ fontSize: '1.3em', fontFamily: 'Montserrat' }}>Access to an insurance 101 knowledge base. </p>
              </Grid.Row>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={2}>
              <Grid.Row>
                <Image size='tiny' src={file} />
              </Grid.Row>
            </Grid.Column>

            <Grid.Column width={5}>
              <Grid.Row>
                <p style={{ fontSize: '1.3em', fontFamily: 'Montserrat' }}>Virtual filing cabinet; policy information in one central location. </p>
              </Grid.Row>
            </Grid.Column>

            <Grid.Column width={1}>
            </Grid.Column>

            <Grid.Column width={2}>
              <Grid.Row>
                <Image size='tiny' src={security}/>
              </Grid.Row>
            </Grid.Column>

            <Grid.Column width={5}>
              <Grid.Row>
                <p style={{ fontSize: '1.3em', fontFamily: 'Montserrat' }}>Designed with security in mind to protect your sensitive information. </p>
              </Grid.Row>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
};

export default WhyBB;



// WEBPACK FOOTER //
// ./src/js/Home/WhyBB.js